import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  dot: {
    '&.active': {
      background: '#ffae49',
      border: '1px solid #ffae49',
    },
    border: '1px solid #ffae49',
    borderRadius: 4,
    composes: ['mx3', 'no-background'],
    height: 8,
    transition: 'background 0.3s',
    width: 8,
  },
  dots: {
    composes: ['flex-columns', 'flex-center', 'items-center', 'mx12'],
    flex: '0 1 0 !important',
  },
});

const RideTooltipDotsFooterComponent = React.memo(({ index, size }) => {
  const classes = useStyles();
  const buttons = Array.from(Array(size - 1).keys());
  return (
    <div className={classes.dots}>
      {buttons.map(num => (
        <span
          key={`button_${num}`}
          className={classnames(classes.dot, {
            active: num === index,
          })}
        />
      ))}
    </div>
  );
});

RideTooltipDotsFooterComponent.propTypes = {
  index: PropTypes.number.isRequired,
  size: PropTypes.number.isRequired,
};

RideTooltipDotsFooterComponent.displayName = 'RideTooltipDotsFooterComponent';

export default RideTooltipDotsFooterComponent;
